module.exports = __webpack_public_path__ + "static/media/12.4dec2500.jpg";